import styled from "styled-components";
import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";
import Radio from "@mui/material/Radio";
import { theme } from "styles/mui-config";
import { Grid } from "@mui/material";
import Slider from "react-slick";
import { QuantityPicker } from "react-qty-picker";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

export const StyledBox = styled(Box)`
  padding-left: 59px;
  padding-right: 59px;
  @media (max-width: 500px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  // @media (max-width: 470px) {
  //   flex-direction: column;
  // }
`;

export const StyledquantityBox = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 350px) {
    flex-direction: column;
    align-items: start !important;
  }
`;

export const StyledQuantityPicker = styled(QuantityPicker)`
  & [data-quantity] input {
    margin-top: 0px !important;
  }
`;
export const StyledStock = styled.div`
  color: #f1394e;
  direction: ltr;
  text-align: right;
  margin-top: 11px;
`;

export const StyledStockCount = styled.div`
  color: #004455;
  direction: ltr;
  text-align: right;
  margin-top: 11px;
`;

export const StyledImgdiv = styled.div`
  border-radius: 4px;
  width: 200px !important;
  height: 200px !important;
  margin: auto;
  max-width: 100%;
`;

export const StyledTopdiv1 = styled.div`
  width: 90%;
  height: 38px;
  background: #78d5ee;
  position: absolute;
  top: -38px;
  border-top-right-radius: 40px;
  border-top-left-radius: 40px;
  text-align: center;
  margin: 0 auto;
  transform: translate(-50%);
  left: 50%;
  @media (max-width: 760px) {
    width: 70%;
  }
`;

export const StyledTopdiv2 = styled.div`
  width: 90%;
  height: 38px;
  background: #ffffff33;
  position: absolute;
  top: -38px;
  border-top-right-radius: 40px;
  border-top-left-radius: 40px;
  text-align: center;
  margin: 0 auto;
  transform: translate(-50%);
  left: 50%;
  @media (max-width: 760px) {
    width: 70%;
  }
`;

export const StyledSlideProductDiv = styled.div`
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 1px -1px,
    rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;
  width: 100%;
  padding: 10px;
  position: relative;
  & img {
    border-radius: 4px;
  }
  & h2 {
    font-size: 15px;
    font-weight: 300;
    line-height: 2.17;
    color: #41464f;
    height: 52px;
    overflow: hidden;
    text-align: right;
    direction: rtl;
  }

  & p {
    margin: 0;
    text-align: left;
    color: #41464f;
    font-size: 17px;
    direction: rtl;
    & span:nth-child(2) {
      font-size: 12px;
    }
  }
  .product-p {
    text-decoration: line-through !important;
    color: #bdc0c4;
  }
`;

export const StyledMain = styled.div`
  // background: linear-gradient(
  //   transparent 50%,
  //   ${theme.palette.primary.dark} 50%
  // ) !important;
  // margin-bottom: 60px;
  padding-right: 48px;
  padding-left: 48px;
`;

export const StyledSlider = styled(Slider)`
  .slick-slide {
    padding: 10px;
  }
  & svg {
    // top: 69% !important;
    color: ${theme.palette.primary.dark} !important;
  }
`;

export const StyledTitle = styled.h2`
  text-align: center;
  font-size: 34px;
  font-family: "Avini";
  margin: 0;
  @media (max-width: 900px) {
    font-size: 27px;
  }
  color: #424242;
  position: relative;
  margin-bottom: 27px;
  &::after {
    content: "";
    width: 74px;
    height: 4px;
    background: ${theme.palette.primary.dark};
    position: absolute;
    bottom: -12px;
    margin: auto;
    left: 50%;
    right: 50%;
    transform: translatex(50%);
    border-radius: 46px;
  }
`;

export const StyledMainBox = styled(Paper)`
  width: 100%;
  height: auto;
  background: #149ec4 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  direction: rtl;
  border-radius 0px !important;
`;

export const StyledRadioBtn = styled(Radio)`
  // border: 2px solid #dedee3 !important;
  margin-left: 15px !important;
  margin-top: 20px !important;
`;

export const StyledProductBeforePrice = styled.p`
  margin: 0;
  font-size: 18px;
  direction: rtl;
  text-decoration: line-through !important;
  color: #bdc0c4;
  margin-left: 20px;
`;

export const StyledMainPaper = styled(Paper)`
  width: 100%;
  height: auto;
  border-radius: 40px !important;
  margin-top: 150px;
  margin-bottom: 100px;
  padding-top: 80px;
  position: relative;
  @media (max-width: 760px) {
    margin-top: 100px;
  }
`;

export const StyledSlideProductDiscount = styled.div`
  // position: absolute;
  width: 42px;
  height: 25px;
  border-radius: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  bottom: 10px;
  right: 10px;
  font-size: 14px;
  background-color: #f1394e !important;
`;

export const StyledProductBeforeDiscountPriceDiv = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  margin-top: 25px;
`;

export const StyledImgMain = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  vertical-align: middle;
`;

export const StyledImgFlexDiv = styled.div`
  width: 100%;
  height: 150px;
  border: 1px solid red;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const StyledImg = styled.img`
  max-width: 100px;
  max-height: 200px;
`;

export const StyledDetailsDiv = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 50px;
  padding-right: 15px;
  direction: rtl;
`;

export const StyledDetailsTitle = styled.h1`
  font-style: normal;
  font-weight: bold;
  font-size: 42px;
  color: #004a5e;
  font-family: "Avini";
  margin-top: -10px;
  margin-bottom: 10px;
  padding-left: 10px;
`;

export const StyledDetailsDescription = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  // margin-top: -35px;
  color: #004455;
  text-align: justify;
  padding-left: 80px;

  @media screen and (max-width: 600px) {
    padding-left: 20px;
  }
`;

export const StyledProductColorDiv = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: 30px;
  padding-left: 80px;
`;

export const StyledProductColorStock = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: 25px;
  padding-left: 80px;
`;

export const StyledAttributes = styled.p`
  // margin-top: 25px;
  display: flex;
  align-items: center;
  font-size: 17px;
`;

export const StyledAttributesCategory = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 28px;
  color: #0080a1;
`;

export const StyledPrice = styled.p`
  color: #009ac2;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
`;

export const StyledButton = styled(Button)`
  height: 45px;
  margin-right: 20px !important;
  @media (max-width: 350px) {
    margin-right: 0px !important;
    margin-top: 20px !important;
  }
`;

export const StyledButtonisLoggedIn = styled(Button)`
  height: 45px;
`;

export const StyledButtonCheck = styled(Button)`
  height: 45px;
`;

export const StyledMainDivSlider = styled.div`
  width: 100%;
  padding-right: 15px;
`;

export const StyledTitleFilteBox = styled.p`
  text-align: center;
  font-size: 34px;
  font-family: "Avini";
  margin: 0;
  @media (max-width: 900px) {
    font-size: 27px;
  }
  color: #424242;
  position: relative;
  margin-bottom: 27px;
  &::after {
    content: "";
    width: 74px;
    height: 4px;
    background: #004a5e;
    position: absolute;
    bottom: -12px;
    margin: auto;
    left: 50%;
    right: 50%;
    transform: translatex(-50%);
    border-radius: 46px;
  }
`;
